import { createSelector } from 'reselect'

const draftsSelector = (state) => state.drafts

export const getDraftData = createSelector([draftsSelector], (state) => state)
